(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["_banner-parent"] && !Shopify.designMode) return;
  try {
    function initBannerGrid() {
    const bannerParents = document.querySelectorAll('.banner-parent');
    bannerParents.forEach(function (bannerParent) {
      const bannerItems = bannerParent.querySelectorAll('.banner-item');
      bannerParent.classList.add('grid-' + bannerItems.length);
    });
  }

  initBannerGrid();  
  if (Shopify.designMode || Shopify.visualPreviewMode) {
    document.addEventListener('shopify:section:select', initBannerGrid);
    document.addEventListener('shopify:section:deselect', initBannerGrid);
    document.addEventListener('shopify:section:reorder', initBannerGrid);
    document.addEventListener('shopify:block:select', initBannerGrid);
    document.addEventListener('shopify:block:deselect', initBannerGrid);
    document.addEventListener('shopify:section:load', initBannerGrid);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["_slide-parent"] && !Shopify.designMode) return;
  try {
    function revealActiveSlideContent(activeSlide) {
    if (!activeSlide) return;
    activeSlide.querySelectorAll('motion-element, [data-motion], .motion-element').forEach(function(el) {
      el.style.opacity = '1';
      el.style.transform = 'translateY(0) translateX(0)';
      el.style.visibility = 'visible';
      el.style.pointerEvents = '';
      el.removeAttribute('hold');
    });
  }

  function hideInactiveSlideContent(slide) {
    if (!slide) return;
    slide.querySelectorAll('motion-element, [data-motion], .motion-element').forEach(function(el) {
      el.style.opacity = '0';
      el.style.transform = 'translateY(20px)';
      el.style.pointerEvents = 'none';
    });
  }

  // FAILSAFE: capture-phase click guard — inactive slide ke clicks block
  function attachClickGuard(wrapper) {
    if (wrapper.dataset.clickGuardAttached === '1') return;
    wrapper.dataset.clickGuardAttached = '1';

    wrapper.addEventListener('click', function(e) {
      var slide = e.target.closest('.swiper-slide');
      if (!slide) return;
      if (!slide.classList.contains('swiper-slide-active')) {
        e.preventDefault();
        e.stopPropagation();
        e.stopImmediatePropagation();
        return false;
      }
    }, true); // capture phase — sab handlers se pehle chalega
  }

  function initSlideAnimations() {
    document.querySelectorAll('.swiper-wrapper_parent').forEach(function(wrapper) {
      attachClickGuard(wrapper);

      var activeSlide = wrapper.querySelector('.swiper-slide-active') || wrapper.querySelector('.swiper-slide:first-child');
      if (activeSlide) revealActiveSlideContent(activeSlide);

      wrapper.querySelectorAll('.swiper-slide').forEach(function(slide) {
        if (slide !== activeSlide) hideInactiveSlideContent(slide);
      });

      var observer = new MutationObserver(function(mutations) {
        mutations.forEach(function(mutation) {
          if (mutation.attributeName === 'class') {
            var slide = mutation.target;
            if (slide.classList.contains('swiper-slide-active')) {
              revealActiveSlideContent(slide);
            } else {
              hideInactiveSlideContent(slide);
            }
          }
        });
      });

      wrapper.querySelectorAll('.swiper-slide').forEach(function(slide) {
        observer.observe(slide, { attributes: true, attributeFilter: ['class'] });
      });
    });
  }

  document.addEventListener('DOMContentLoaded', initSlideAnimations);
  setTimeout(initSlideAnimations, 500);
  setTimeout(initSlideAnimations, 1500);

  if (Shopify.designMode || Shopify.visualPreviewMode) {
    document.addEventListener('shopify:section:select', initSlideAnimations);
    document.addEventListener('shopify:section:deselect', initSlideAnimations);
    document.addEventListener('shopify:section:reorder', initSlideAnimations);
    document.addEventListener('shopify:block:select', initSlideAnimations);
    document.addEventListener('shopify:block:deselect', initSlideAnimations);
    document.addEventListener('shopify:section:load', initSlideAnimations);
  }
  } catch(e) { console.error(e); }
})();

})();
